module.exports = __webpack_public_path__ + "static/pregnancy1920_1541-f32b1b2a4eea78db5ea8b36de8e64dae.png";